import { render } from "./dateBet.vue?vue&type=template&id=163f9862&scoped=true"
import script from "./dateBet.vue?vue&type=script&lang=js"
export * from "./dateBet.vue?vue&type=script&lang=js"

import "@/styles/pt.css?vue&type=style&index=0&lang=css"
import "./dateBet.vue?vue&type=style&index=1&id=163f9862&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-partnerpage-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-163f9862"]])

export default __exports__